import styled, { keyframes, css } from 'styled-components';
import { BLACK_COLOR, DEFAULT_FONT, WHITE_COLOR } from '../../../../styles/variables';
import { leftSlide, rightSlide } from '../../styles';

const fadeIn = keyframes`
  100% {
    opacity: 1;
  }
`;

export const DocumentPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  .filter-container {
    width: 100%;
    background: #f6f6f6;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 15px 15px;
    margin-bottom: 10px;
    gap: 5px;
    min-height:280px;

    p {
      font-size: 12px;
    }

    .filter-button {
      background-color: #000;
      color: #fff;
      border-radius: 20px;
      width: fit-content;
      padding: 0px 10px;
      font-size: 10px;
    }

    .italic-font {
      font-style: italic;
    }
    .card-bottom {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      border-top: 0.5px solid #00000073;
      padding-top: 5px;
      .removed-info {
        font-size: italic;
        font-size: 12px;
        color: #00000073;
      }
      .roll-back {
        display: flex;
        gap: 2px;
        justify-content: center;
        align-items: center;
        color: #000000;
        font-size: 10px;
        border: 1px solid #000;
        border-radius: 5px;
        padding: 0px 3px;
        cursor: pointer;
      }
    }

    .filtered-key {
      background-color: #C9C8CC;
      border-radius: 5px;
      padding: 2px 5px;
      font-weight: bold;
      width: fit-content;
      font-size: 11px;
    }

    .docs-filter .ant-select-selection.ant-select-selection--multiple {
      height: 75px;
    }
    .ant-select-selection__choice {
      font-size: 0.7rem !important;
      background: #917bf7 !important;
      border: 0;
      height: 32px;
      border-radius: 15px !important;
      line-height: unset !important;
    }
  }
  .chart-wrapper {
    width: 100%;
    background: #f6f6f6;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 0px;
    margin-bottom: 10px;
  }
  .chart-title {
    padding: 6px;
    border-radius: 10px;
    background-color: yellow;
    font-size: 14px;
    font-weight: bold;
  }
  .chart-wrapper .apexcharts-title-text {
    background-color: yellow; /* Your desired background color */
    padding: 5px;
    border-radius: 4px;
  }
  .chart-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height:200px;
    max-height:250px;
    overflow-y: scroll;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
      // .apexcharts-canvas{
      //   height: ${({barchartHeight}) => barchartHeight }px !important;
      // }
  }
  .bar-chart{
    .apexcharts-legend-marker {
       cursor: default !important; /* Disables pointer cursor on legend text */
    };
}

`;

export const TableContainer = styled.div`
   .remove-view-record{
    transform: translateX(5%);
    opacity: 0;
    animation: ${leftSlide} 1s forwards;
    animation-delay: 0.3s;   
   }
   height:100%;
  .filterContainer {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-between;
  }
  .rightSideFilter {
    width: 50%;
    display: flex;
    column-gap: 15px;
    font-size: 12px;
    align-items: center;
    justify-content: flex-end;
    @media (max-width: 1024px) {
      width: 100%;
      justify-content: flex-start;
    }
  }
  .singleFilter {
    border: 1px solid #d9d9d9;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 4px 14px;
    cursor: pointer;
    background: #ffffff;
    color: #000000;
  }
  .clearBtn {
    color: blue;
    cursor: pointer;
  }
  .ant-table-align-center {
    font-weight: 800;
    background: #ffffff;
  }
  .pagination-container .ant-pagination {
    background: white;
    margin: 10px 0 0 0 !important;
    padding: 10px;
    display: flex;
    float: unset;
    justify-self: center;
    height: 75%;
    overflow: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  .docCount {
    display: flex;
    column-gap: 10px;
    font-size: 12px;
    align-items: center;
    color: #000000;
    .desc {
      font-size: 16px;
    }
    .count {
      font-size: 18px;
      font-weight: 800;
    }
    padding: 5px 0;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
  .ant-table-body {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  .table-wrapper {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    // overflow: hidden;
  }  
  .failure_reason:disabled {
    background-color: unset !important;
  }

  .pagination-container .ant-table-tbody .ant-checkbox-wrapper.ant-checkbox-wrapper-checked {
   pointer-events: ${({selectedAll}) => selectedAll ? 'none' : 'auto' };
  }
 
  .pagination-container .ant-table-tbody span:has(.ant-checkbox-wrapper.ant-checkbox-wrapper-checked) {
   cursor: ${({selectedAll}) => selectedAll ? 'not-allowed' : 'pointer'};
  }
`;

export const BatchRejectionContainer = styled.div`
  .actionButton {
    display: flex;
    margin-top: 20px;
    justify-content: center;
  }
  .emailBox {
    max-height: 130px;
    overflow: auto;
    // max-width: 500px;
  }
  .m-10 {
    margin-top: 10px;
  }
  @media (min-width: 2000px) {
    .textArea {
      width: 600px;
    }
  }
`;

export const MultipleSelect = styled.div`
  position: relative;
  border-radius: 4px;

  .dropdown-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px;
  }

  .dropdown-icon {
    font-size: 24px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    background-color:#f6f6f6
    .anticon {
      rotate: 90deg;
    }
  }
  .dropdown-list {
    border-radius: 8px;
    border: 1px solid #c1c1c1;
    padding: 10px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
    max-height: 200px;
    overflow-y: auto;
    background-color: #f6f6f6;
    position: absolute;
    width: 280px;
    right: 0px;
    z-index: 10;
    top: 40px;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }

  .list-desc {
    padding: 8px;
    cursor: pointer;
    color: #000;
    font-weight: bold;
  }
  .ant-checkbox-group-item {
    padding: 10px;
    display: block;
    margin-left: 15px !important;
    margin-right: 0px;
  }

  .ant-checkbox + span {
    padding-left: 16px !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner::after {
    // border: 2px solid black;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    // background-color: white !important;
  }
`;

const overflowScroll = css`
  overflow-y: scroll;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const JobQueueCard = styled.div`
  padding: 20px;
  background: #f6f6f6;
  border-radius: 24px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  width: ${props => props.width || "100%"};
  align-items: ${props => props.alignCenter ? 'center' : 'none' };
  .ant-tabs {
    overflow: visible;
  }
`
export const BatchList = styled.div`
  width: 100%;
  // min-height: 225px;
  border-radius: 12px;
  padding: 10px;
  background: #fff;
  column-gap: 20px;
  position:relative;
  cursor:pointer;
  border: ${props => props.selected ? '1px solid #9c179e' : 'none'}

  .user-details {
    font-weight: bold;
    font-size:14px;
    color: black;
  }
  .date {
    font-size:12px;
    color: black;
  }

  .totalCount{
    font-weight: bold; 
    color: black;
    padding-top: 10px;
  }
  
  .tags{
    background: #ccc;
    border-radius: 8px; 
    padding: 6px 8px;
  }

  :hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    -webkit-transition: box-shadow 0.6s ease-in;
  }  
`
export const PrintBatchDetails = styled.div`
  display: flex;
  row-gap: 15px;
  flex-direction: column;
  max-height: 500px;
  overflow: scroll;
  padding-bottom: 10px;
  ${overflowScroll}
  .filtered-key {
    background-color: #C9C8CC;
    border-radius: 5px;
    padding: 2px 5px;
    font-weight: bold;
    width: fit-content;
    font-size: 11px;
  }
  .emptyList {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 10px;
    font-size: 13px;

    .ant-empty {
      margin-top:100px !important;
    }
  }
`
export const TaglistDetails = styled.div`
  display: flex
  gap: 10px;
  flex-wrap: wrap;
  height: 100px;
  border: 1px dotted gray;
  border-radius: 8px;
  padding: 5px;
  ${overflowScroll}
  .tagsContent {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    align-content: flex-start;
    border: 1px groove;
    padding: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
  }
`

export const SearchExclusionFilters = styled.div`
  width: 100%;
  .container {
    border: 1px solid;
    border-radius: 5px;
    padding: 5px;
  }
`;

export const JobQueueContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  border-radius: 10px;
  font-family: lato;
  min-height:550px;

  .job_queue_info, .job_queue_table {
    width: calc(25% - 16px);
    min-width: 0;
  }
  .job_queue_table {
    width: calc(50% - 16px);
  }

  .middleContainer {
    opacity: 0;
    animation: ${fadeIn} 1s forwards;
    animation-delay: 0.3s;
  }
  .rightcontainer {
    transform: translateX(5%);
    opacity: 0;
    animation: ${leftSlide} 1s forwards;
    animation-delay: 0.3s;
  }

  .rightContainerTitle {
    display: flex;
    justify-content: center;
    font-size: 15px;
    font-weight: bold;
    padding-bottom: 10px;
  }

  .unknownMessageContainer{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 100%;
    font-size: 20px;
  }
  .search_container {
    margin-bottom: 20px;
    width: 50%;
  }
  .stats_container {
    display: flex;
    flex-direction: column;
    width: 100%;
    row-gap: 25px;
    height: 100%;
  }

  .batch_list {
    display: flex;
    column-gap: 15px;
    margin-top: 20px;
  }

  .pagination-container .ant-pagination {
    background: white;
    margin: 10px 0 0 0 !important;
    padding: 10px;
    display: flex;
    float: unset;
    justify-self: center;
    height: 75%;
    overflow: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }

  @media (max-width: 768px) {
    flex-direction: column;
    .leftContainer {
      width: 100%;
    }
    .middleContainer {
      width: 100%;
    }
    .rightcontainer {
      width: 100%;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    flex-wrap: wrap;
    .leftContainer {
      width: 48%;
    }
    .middleContainer {
      width: 48%;
    }
    .rightcontainer {
      width: 100%;
      display: block;
    }
  }
  @media (max-width: 1024px) {
    overflow: scroll;
    height: 650px;
  }
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 1024px) and (max-height: 700px) {
    max-height: 500px;
    min-height:unset;
  }   

  .count-card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px
  }

  .count-card {
    width: 45%;
    height: 130px;
    background: #fff;
    position: relative;
    display: flex;
    flex: 1 1 calc(45% - 10px);
    place-content: center;
    place-items: center;
    overflow: hidden;
    border-radius: 20px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

    .card-content {
      z-index: 1;
      display: flex;
      flex-direction: column;
      color: #000;
      align-items: center;
      span{
        font-size: 25px;
        color: #66d4d7
      }
      p {
        font-size: 15px;
        text-align: center;
      }
    }
  }

  .count-card::before {
    content: '';
    position: absolute;
    width: 100px;
    background-image: linear-gradient(180deg, #6CE5E8, #6CE5E8);
    height: 300%;
    animation: rotBGimg 3s linear infinite;
    transition: all 0.2s linear;
    opacity: 0;
    pointer-events: none;
  }
  .count-card:hover::before {
    opacity: 1;
  }

  @keyframes rotBGimg {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .count-card::after {
    content: "";
    position: absolute;
    background: #fff;
    inset: 5px;
    border-radius: 15px;
  }

`;

export const CardWrapper = styled.div`
  width: 100%;
  height: 50%;
`;

export const Card = styled.div`
  background: #f6f6f6;
  border-radius: 20px;
  width: 100%;
  height: ${props => props.height || 'calc(100% - 40px)'};
  max-height: 550px;
  padding: ${props => props.padding ? props.padding : "30px"};
  overflow: ${props => props.overFlowScroll && 'scroll'};
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const BatchStatus = styled.div`
  text-align: center;
  margin-top: ${props => props.marginTop || '10px'};
  color: black;
  font-weight: 700;
  // font-family: lato;
`;

export const CardTitle = styled.div`
  text-align: ${props => props.textAlign || 'left'};
  padding: 10px;
`;
export const Label = styled.div`
  padding: 3px 0px;
  font-weight: ${props => props.fontWeight || 'unset'};
  color: ${props => props.color || 'unset'};
  // font-family: lato;
`;

const tablePayloadContainer = css`
     background-color: #f6f8fa;
     padding: 10px;
     border-radius: 5px;
     overflow: auto;
     min-height: 300px;
     max-height: 350px;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
`;

export const PayloadBody = styled.pre`
   ${tablePayloadContainer};
`;

export const FailureReasonsContainter = styled.div`
    ${tablePayloadContainer};
`
export const AnimeCloseIcon = styled.div`
.arrow {
  position: relative;
  background: black;
  width: 30px;
  height: 5px;
  transition: 5px;
  border-radius: 1rem;
  transform-origin: right center;
}

.arrow:before {
  display: block;
  content: "";
  position: absolute;
  left: 0;
  background: black;
  width: 20px;
  height: 5px;
  transform-origin: 0.2rem center;
  transition: 0.5s;
  border-radius: 1rem;
  transform: rotate(-35deg);
}

.arrow:after {
  display: block;
  content: "";
  position: absolute;
  left: 0;
  background: black;
  width: 20px;
  height: 5px;
  transform-origin: 0.2rem center;
  transition: 0.5s;
  border-radius: 1rem;
  transform: rotate(35deg);
}
`
const listAnimation = keyframes`
  0% {
    opacity: 0;
    top: 100px;
    // transform: scale(0);
  }
  100% {
    opacity: 1;
    top: 0px;
    // transform: scale(1);
  }
`;

export const RecordContainter = styled.div`
  ${overflowScroll}
  max-height:340px;

  .ant-card{
    margin: 10px 0px !important;
    border-radius:8px;
    transition: transform 0.1s linear;*/
    transition: background 0.5s ease-in-out;
    &.animate {
      position: relative;
      opacity: 0;
      // transform-origin: 0 0;
      animation: ${listAnimation} 0.5s ease-in-out;
      animation-delay: ${props => `${props.index === 0 ? 0 : props.index * 0.3}s`};
      animation-fill-mode: forwards;
    }
    // :hover{
    //  cursor: pointer;
    //   box-shadow: 0 0 11px rgba(33,33,33,.2); 
    // }
  }
  .ant-card-body{
    padding: 8px;
  }
  .ant-card-actions{
    background: unset;
    display: flex;
    justify-content: center;
    align-items: center;
  } 
  .ant-card-actions > li {
    margin: 5px 0px;
  } 
  .ant-card-actions > li > span {
    font-size:12px !important;
  }
  .ant-card-actions > li > span:hover {
     color:unset;
  }

`;

export const StatusColumnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StatusLabel  = styled.p`
  background-color: ${props => props.backgroundColor || ''};
  color: ${props => props.color || ''};
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
  width: fit-content;
  text-transform: uppercase;
`;


export const PillWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  align-items: end;
`;

export const InnerWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  text-align: start;
  gap: 6px;
`;

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 16px;
  gap: 0;
  font-family: inherit;
  border: 1px solid;
  transition: box-shadow 0.2s ease;

  ${({ status }) =>
    status.toLowerCase() === 'approved' &&
    css`
      background: #eaf3de;
      border-color: #639922;
    `}

  ${({ status }) =>
    status.toLowerCase() === 'rejected' &&
    css`
      background: #fcebeb;
      border-color: #e24b4a;
    `}
`;

export const PillLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;

  ${({ status }) =>
    status.toLowerCase() === 'approved' &&
    css`
      color: #3b6d11;
    `}

  ${({ status }) =>
    status.toLowerCase() === 'rejected' &&
    css`
      color: #a32d2d;
    `}
`;

export const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 20px;
  background: #d0d0d0;
  margin: 0 14px;
  flex-shrink: 0;
`;

export const MetaText = styled.span`
  font-size: 12px;
  color: #666;
  white-space: nowrap;
`;

export const UserText = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #222;
  white-space: nowrap;
`;

export const ReasonRow = styled.div`
  font-size: 12px;
  color: #555;
  padding: 0 2px;
  max-width: 480px;
  line-height: 1.5;
`;

export const ReasonLabel = styled.span`
  color: #a32d2d;
  font-weight: 600;
  margin-right: 4px;
`;